import './style.less';

class IntegrationOauthController {
  constructor(
    Authentication,
    IntegrationService,
    WindowLocation,
    $state,
    $location,
    $window
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      IntegrationService,
      WindowLocation,
      $state,
      $location,
      $window,
    });
  }

  goToIntegrations(type) {
    this.$state.go('settings', { tab: 'integrations', type });
  }

  async updateParametersFromUrl(integration) {
    const payload = this.IntegrationService.parseParameters(integration, this.$location.search());

    if (Object.keys(payload).length) {
      try {
        await this.IntegrationService.setParameters(integration, payload);
      } catch (e) {
        return this.goToIntegrations(integration.type);
      }
    }
  }

  async $onInit() {
    const { code, platform, origin = null, state = null, error = null } = this.$state.params;
    const integration = await this.IntegrationService.getIntegrationByPlatform(platform);

    if (!integration || error) {
      return this.goToIntegrations();
    }

    if (integration.parameters) {
      this.updateParametersFromUrl(integration);
    }

    try {
      const res = await this.IntegrationService.oauth(integration, code, origin, state);

      if (res.data?.redirect) {
        this.WindowLocation.href = res.data.redirect;
        return;
      }
    } finally {
      this.goToIntegrations();
    }
  }

}

export default {
  template: `
    <div class="integration-oauth__container">
      <sling-loader></sling-loader>
    </div>
  `,
  controller: IntegrationOauthController,
};
